document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.percent-element-grid').forEach(function (grid) {

        const items = Array.from(grid.querySelectorAll('.percent-element-item'));

        if (items.length < 2) return;

        const percents = items.map(function (el) {
            return parseFloat(el.dataset.percent) || 0;
        });

        const maxPercent = Math.max(...percents);
        const maxIndex = percents.indexOf(maxPercent);

        if (maxIndex !== 0) {
            grid.insertBefore(items[maxIndex], items[0]);
        }

        const sorted = Array.from(grid.querySelectorAll('.percent-element-item'));

        const leftItem = sorted[0];
        const rightItems = sorted.slice(1);

        const rightWrapper = document.createElement('div');
        rightWrapper.className = 'percent-element-right';

        rightItems.forEach(function (item) {
            rightWrapper.appendChild(item);
        });

        grid.appendChild(rightWrapper);

        function getGapPx() {
            return 0.75 * parseFloat(getComputedStyle(document.documentElement).fontSize);
        }

        function applyDesktop() {

            const gapPx = getGapPx();

            const currentRightItems = Array.from(rightWrapper.querySelectorAll('.percent-element-item'));

            const rightTotal = currentRightItems.reduce(function (sum, el) {
                return sum + (parseFloat(el.dataset.percent) || 0);
            }, 0);

            grid.style.height = '';
            grid.style.flexDirection = '';

            rightWrapper.style.height = '';
            rightWrapper.style.width = '';
            rightWrapper.style.flex = '';

            leftItem.style.width = maxPercent + '%';
            leftItem.style.height = '';
            leftItem.style.flex = '0 0 ' + maxPercent + '%';

            const totalGapPx = gapPx * (currentRightItems.length - 1);

            currentRightItems.forEach(function (item) {

                const p = parseFloat(item.dataset.percent) || 0;
                const ratio = rightTotal > 0 ? p / rightTotal : 0;
                const flexBasis = 'calc(' + (ratio * 100) + '% - ' + (totalGapPx * ratio) + 'px)';

                item.style.width = '';
                item.style.height = flexBasis;
                item.style.flex = '0 0 ' + flexBasis;

            });

        }

        function applyMobile() {

            const gapPx = getGapPx();

            grid.style.height = 'auto';
            grid.style.flexDirection = 'column';

            rightWrapper.style.height = 'auto';
            rightWrapper.style.width = '100%';
            rightWrapper.style.flex = 'none';

            const allItems = [leftItem, ...rightItems];

            const totalPercent = allItems.reduce(function (sum, item) {
                return sum + (parseFloat(item.dataset.percent) || 0);
            }, 0);

            const totalHeight = window.innerHeight * 0.9;
            const totalGapPx = gapPx * (allItems.length - 1);
            const usableHeight = totalHeight - totalGapPx;

            allItems.forEach(function (item) {

                const percent = parseFloat(item.dataset.percent) || 0;
                const ratio = totalPercent > 0 ? percent / totalPercent : 0;
                const height = usableHeight * ratio;

                item.style.flex = 'none';
                item.style.width = '100%';
                item.style.height = height + 'px';

            });

        }

        function applyLayout() {
            if (window.innerWidth <= 640) {
                applyMobile();
            } else {
                applyDesktop();
            }
        }

        applyLayout();

        window.addEventListener('resize', applyLayout);

    });

});

document.addEventListener('DOMContentLoaded', function () {

    function animateCounter(el) {
        // Zahl und Einheit aus dem Text-Node lesen (nicht aus dem <span>)
        var textNode = Array.from(el.childNodes).find(function (n) {
            return n.nodeType === Node.TEXT_NODE && n.textContent.trim() !== '';
        });
        if (!textNode) return;

        var raw = textNode.textContent.trim();
        var match = raw.match(/^([\d,.]+)(.*)$/);
        if (!match) return;

        var target = parseFloat(match[1].replace(',', '.'));
        var suffix = match[2];
        var decimals = match[1].includes(',') || match[1].includes('.')
            ? match[1].split(/[,.]/).pop().length
            : 0;
        var duration = 2500;
        var start = null;

        function step(timestamp) {
            if (!start) start = timestamp;
            var progress = Math.min((timestamp - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
            var current = (eased * target).toFixed(decimals).replace('.', ',');
            textNode.textContent = current + suffix;

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                textNode.textContent = match[1] + suffix;
            }
        }

        requestAnimationFrame(step);
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.3 });

    document.querySelectorAll('.percent-element-item-percent').forEach(function (el) {
        observer.observe(el);
    });

});